'use strict';

var userModule = angular.module('t2g.user', [
  'gettext',
  'ui.router',
  require('t2g.common.services.modelService').name,
  require('t2g.common.services.notificationService').name,
]);

module.exports = userModule;

userModule.controller('UserCtrl', require('./UserCtrl'));
userModule.controller('UserModalCtrl', require('./userModalCtrl'));

userModule.config(function($stateProvider) {
  $stateProvider.state('private.main.user', {
    url: '/user',
    title: 'User',
    templateUrl: '/app/modules/user/UserView.html?v=4.5.6',
    controller: 'UserCtrl',
    resolve: {
      userResolve: function($q, UserModel) {
        var deffered = $q.defer();

        UserModel.get(function(error, response) {
          if (error) {
            deffered.reject(error);
          } else {
            deffered.resolve(response);
          }
        });

        return deffered.promise;
      },
    },
  });
});

// TODO: move to modal service
userModule.factory('UserModal', function($compile, $rootScope, $http, $templateCache) {
  var UserModal = new Object();
  var scope = $rootScope.$new();
  var body = $(document).find('body');
  var modalHTML = '';

  /**
   * load the modal template file
   */
  $http.get('/app/modules/user/UserModal.html').then(function(response) {
    $templateCache.put('UserModal.html', response.data);
  });

  /**
   * show the modal
   */
  UserModal.open = function(course) {
    modalHTML = $compile($templateCache.get('UserModal.html'))(scope);
    modalHTML.controller().setCurrentItem(course);
    body.append(modalHTML);

    $('#userModal').modal({
      show: true,
      backdrop: 'static',
      keyboard: true,
    });
  };

  /**
   * hide the modal and clear the current model
   */
  UserModal.close = function() {
    $('#userModal').modal('hide');

    // remove modal html
    angular
      .element($('#userModal'))
      .scope()
      .$destroy();
    modalHTML.remove();
    $('.modal-backdrop').remove();
    $('body').removeAttr('class');
  };

  return UserModal;
});



// WEBPACK FOOTER //
// ./src/app/modules/user/userModule.js